<template>
	<div>
		<compWrapper v-if="type==='query'" title="信用额度详情" theme="primary">
			<compFormQuery align="center" class="margin-top-15" :formdata="getBase" :value="formData"></compFormQuery>
		</compWrapper>
		<compLog v-if="type==='query'" :columns="getLogList" wrapper :data="logList"></compLog>
		<compFormEdit v-if="type!='query'" ref="formbase" align="center" class="margin-top-15" :formdata="getBase" v-model="formData"></compFormEdit>
		<vButtonGroup v-if="type!='query'" class="text-right margin-top-10">
			<vButton theme="primary" @click="submit">保存</vButton>
			<vButton @click="cancel">返回</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpQueryCredit, HttpSaveCredit } from '@/service/credit';
import { mapGetters } from "vuex";
export default {
	props: {
		params:{
			type:Object,
			default:function(){
				return {}
			}
		}
	},
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compLog: () => import("@components/templates/log")
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			logList: [],
			formData: {
			}
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
        ...mapGetters("dictionary", ["getNextOrgList"]),
		getBase() {
			const isEdit = this.params.type === 'edit';
			return [
                {
					label: "客户",
					tag: "vSelect",
					key: "organizationId",
					span: 18,
					query: isEdit,
					show: true,
                    props: {
                        filterable: true
                    },
                    options: this.getNextOrgList
                },
                {
                    label: "信用额度(USD)",
                    key: "quota",
					tag: "vInputNumber",
					span: 18,
                }
			];
		},
		getLogList() {
			return [
				{
					title: "操作人",
					key: "opUserName"
				},
				{
					title: "操作类型",
					key: "opAction"
				},
				{
					title: "更改字段",
					key: "changeField"
				},
				{
					title: "更改前值",
					key: "beforeChange"
				},
				{
					title: "更改后值",
					key: "afterChange"
				},
				{
					title: "创建时间",
					key: "opAt"
				}
			];
		},
	},
	methods: {
		onCancel() {
			this.$router.push({
				name: "creditList"
			});
		},
		cancel() {
			this.$emit('on-close')
		},
		getDetail() {
			if (this.params.type === "add") return;
			this.loading = true;
			HttpQueryCredit({
				id: this.id||this.params.id,
			}).then(res => {
				const data = res.data || {};
				this.logList = data.fbbLogs;
				delete data.fbbLogs;
				this.formData = data;
				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpSaveCredit({
				id: this.formData.id,
				organizationId: this.formData.organizationId,
				quota: this.formData.quota,
			}).then(res => {
				this.loading = false;
				this.cancel();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
	}
};
</script>
